import axios from "axios";

// 1. URL Base con fallback para evitar errores si el .env falla
const server_url = process.env.REACT_APP_PRODUCCION || 'http://localhost:3000';

// Rutas públicas que NO requieren token (kiosko / pantallas de sala)
const RUTAS_PUBLICAS = [
    '/',
    '/auth/login',
    '/auth/superadmin',
    '/auth/select-ubicacion-pantallas',
    '/auth/registro-pantallas',
    '/tickets/crear',
    '/tickets/crear2',
    '/tickets/registra-cliente',
    '/tickets/get-cliente',
    '/tickets/busca-paciente',
    '/tickets/tiposAtencion',
    '/tickets/ubicaciones',
    '/tickets/entidades',
    '/tickets/cola',
    '/tickets/cola2',
    '/tickets/get-cola',
    '/tickets/ultimos',
    '/tickets/crear-ticket',
    '/tickets/tts',
    '/tipos-atencion/lista-para-ticket',
    '/videos/lista-videos-mostrar',
    '/superadmin/login-superadmin',
    '/superadmin/login-vendedor',
];

const serverApi = axios.create({
    baseURL: `${server_url}/api`,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 2. Interceptor de Petición — valida token antes de enviar al servidor
serverApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            // El backend usa x-token en lugar de Bearer
            config.headers['x-token'] = token;
        } else {
            // Sin token: verificar si la ruta es pública
            const url = config.url || '';
            const esPublica = RUTAS_PUBLICAS.some(ruta => url.includes(ruta));

            if (!esPublica) {
                // Ruta protegida sin token → cerrar sesión de inmediato
                window.dispatchEvent(new CustomEvent('sesion-expirada'));
                return Promise.reject(new axios.Cancel('Sin token — sesión cerrada'));
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 3. Interceptor de Respuesta — manejo global de errores HTTP
serverApi.interceptors.response.use(
    (response) => response,
    (error) => {

        // Si es una cancelación interna (sin token), ignorar silenciosamente
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }

        if (error.response) {

            // El servidor respondió con un código de error (4xx, 5xx)
            switch (error.response.status) {
                case 401:
                    console.error('No autorizado - Token inválido o expirado');
                    // Limpiar sesión y disparar evento global
                    if (localStorage.getItem('token')) {
                        window.dispatchEvent(new CustomEvent('sesion-expirada'));
                    }
                    break;
                case 403:
                    console.error('Prohibido - No tienes permisos');
                    break;
                case 500:
                    console.error('Error interno del servidor');
                    break;
                default:
                    console.error(`Error ${error.response.status}:`, error.response.data);
            }

        } else if (error.request) {
            // La petición se hizo pero no hubo respuesta (Error de red/CORS)
            console.error('Error de red: No se pudo conectar con el servidor');
        } else {
            console.error('Error al configurar la petición:', error.message);
        }

        return Promise.reject(error);
    }
);

export default serverApi;